import { AuthApi, ToastStateHandler } from '../../../api';
import { useContainer } from '../../useContainer';
import { LocalStorage } from '../../../util/LocalStorage';
import { useNavigate } from 'react-router';
import { useAddAuth } from '../useAddAuth';
import useHttpPostSendVerificationCode from './useHttpPostSendVerificationCode';
import { useJoinToken } from '../useJoinToken';
import { useTranslation } from '../../useTranslation';

interface SignInValues {
    username: string;
    password: string;
}

const useHttpPostSignIn = () => {
    const { t } = useTranslation('auth');
    const authApi: AuthApi = useContainer(AuthApi);
    const storage: LocalStorage = useContainer(LocalStorage);
    const navigate = useNavigate();
    const toastHandler = useContainer(ToastStateHandler);
    const { addUserAuth } = useAddAuth();
    const { exec: resendConfirmationCode } = useHttpPostSendVerificationCode();

    const { getJoinTokenAsQuery } = useJoinToken();

    const exec = (signIn: SignInValues) => {
        const { exec, clearCache, abort } = authApi.signIn({
            body: {
                ...signIn,
            },
            onSuccess: res => {
                storage.setAuth(res.body.tokens);
                addUserAuth(res.body.user);
                clearCache();
            },
            onError: error => {
                if (error.includes('User not confirmed')) {
                    resendConfirmationCode(signIn.username);
                    navigate(`/auth/verification?email=${signIn.username}${getJoinTokenAsQuery(false)}`);
                } else {
                    toastHandler.push('error', 'Sing In', t('signInError'));
                }
            },
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpPostSignIn;
